export function convertObjectToQueryString(params: Record<string, unknown>) {
  const queryStringParams = Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key] as string)}`)
    .join('&');
  return queryStringParams;
}
